import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { LoggedUserContext } from 'contexts';

const PrivateRoute = ({ redirect, ...props }) => {
  const { loggedUser } = useContext(LoggedUserContext);

  if (loggedUser) {
    return <Route {...props} />;
  }

  return (
    <Redirect
      to={{
        pathname: redirect,
        state: { from: props.location }
      }}
    />
  );
};

export default PrivateRoute;
